/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface BranchRenewalHistoryResponseDto {
  createdUserId: string;
  createdUsername: string;
  createdAt: Date;
  updatedUserId: string;
  updatedUsername: string;
  updatedAt: Date;
  deletedUserId: string;
  deletedUsername: string;
  deletedAt: Date;
  id: string;
  status: BranchRenewalHistoryResponseDto.StatusEnum;
  documentUrl: string;
  remark: string;
  contractStartDate: string;
  contractEndDate: string;
}
// tslint:disable-next-line:no-namespace
export namespace BranchRenewalHistoryResponseDto {
  export type StatusEnum = 'pending' | 'in_progress' | 'completed';
  export const StatusEnum = {
      Pending: 'pending' as StatusEnum,
      InProgress: 'in_progress' as StatusEnum,
      Completed: 'completed' as StatusEnum,
  };
}
